import { PERMISSION_SCOPES } from "components/layout/AccessControl";

import { PATHS } from "./routeConfig";

export const MenuTypes = {
  GROUP: "group",
  ITEM: "item",
  COLLAPSE: "collapse",
  COLLAPSE_LIST: "collapse-list",
};

export const MenuList = [
  {
    title: "Main",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Dashboard",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Dashboard,
        badge: 4,
        badgeBg: "primary",
        badgeClassName: "badge-numeric",
        href: PATHS.DASHBOARD,
        icon: "inic inic-home",
      },
      {
        title: "Users",
        type: MenuTypes.COLLAPSE,
        role: PERMISSION_SCOPES.Users,
        icon: "inic inic-person",
        eventKey: PATHS.USER,
        items: [
          {
            title: "Users list",
            role: PERMISSION_SCOPES.User,
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.USER_LIST}`,
            // linkClassName: "text-black",
          },
          {
            title: "Worker List",
            role: PERMISSION_SCOPES.Workers,
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.WORKER_LIST}`,
            // linkClassName: "text-black",
          },
          {
            title: "Admin List",
            role: PERMISSION_SCOPES.Admin_User,
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.ADMIN_USER}`,
            // linkClassName: "text-black",
          },
        ],
      },
      {
        title: "Statistics",
        role: PERMISSION_SCOPES.Dashboard,
        type: MenuTypes.COLLAPSE,
        eventKey: PATHS.STATISTICS,
        icon: "inic inic-bar-chart",
        items: [
          {
            title: "Worker Statistics",
            role: PERMISSION_SCOPES.Dashboard,
            type: MenuTypes.ITEM,
            href: `${PATHS.STATISTICS}/${PATHS.WORKER_STATISTICS}`,
          },
          {
            title: "Worker Statistics Report",
            role: PERMISSION_SCOPES.Dashboard,
            type: MenuTypes.ITEM,
            href: `${PATHS.STATISTICS}/${PATHS.WORKER_STATISTICS_REPORT}`,
          },
        ],
      },
      {
        title: "Content",
        type: MenuTypes.COLLAPSE,
        role: PERMISSION_SCOPES.StaticPages,
        eventKey: PATHS.CONTENT,
        icon: "inic inic-file",
        items: [
          {
            title: "Static Pages",
            role: PERMISSION_SCOPES.StaticPages,
            type: MenuTypes.ITEM,
            href: `${PATHS.CONTENT}/${PATHS.STATIC_PAGES}`,
            // linkClassName: "text-black",
          },
          // {
          //   title: "Blogs",
          //   role: PERMISSION_SCOPES.Blog,
          //   type: MenuTypes.COLLAPSE_LIST,
          //   items: [
          //     {
          //       title: "Blog List",
          //       role: PERMISSION_SCOPES.Blog,
          //       type: MenuTypes.ITEM,
          //       href: `${PATHS.CONTENT}/${PATHS.BLOGS}/${PATHS.BLOG_LIST}`,
          //       // linkClassName: "text-black",
          //     },
          //     {
          //       title: "Blog Category",
          //       role: PERMISSION_SCOPES.BlogCategory,
          //       type: MenuTypes.ITEM,
          //       href: `${PATHS.CONTENT}/${PATHS.BLOGS}/${PATHS.BLOG_CATEGORY}`,
          //       // linkClassName: "text-black",
          //     },
          //   ],
          // },
          // {
          //   title: "FAQs",
          //   role: PERMISSION_SCOPES.FaqCategory,
          //   type: MenuTypes.COLLAPSE_LIST,
          //   items: [
          //     {
          //       title: "FAQ List",
          //       role: PERMISSION_SCOPES.FaqCategory,
          //       type: MenuTypes.ITEM,
          //       href: `${PATHS.CONTENT}/${PATHS.FAQS}/${PATHS.FAQS_LIST}`,
          //       // linkClassName: "text-black",
          //     },
          //     {
          //       title: "FAQ Category",
          //       role: PERMISSION_SCOPES.FaqCategory,
          //       type: MenuTypes.ITEM,
          //       href: `${PATHS.CONTENT}/${PATHS.FAQS}/${PATHS.FAQS_CATEGORY}`,
          //       // linkClassName: "text-black",
          //     },
          //   ],
          // },
        ],
      },
      {
        title: "Role",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Role,
        href: PATHS.ROLE,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-circle-tick",
      },
      {
        title: "Clubs",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Club,
        href: PATHS.CLUB,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-emoji-events",
      },
      {
        title: "Brand",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Brand,
        href: PATHS.BRAND,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-discount",
      },
    ],
  },
  {
    title: "General",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Email Templates",
        role: PERMISSION_SCOPES.Email_Template,
        type: MenuTypes.ITEM,
        href: PATHS.EMAIL_TEMPLATES,
        icon: "inic inic-email",
        badge: 4,
        badgeBg: "primary",
        badgeClassName: "badge-numeric",
      },
      {
        title: "Master",
        role: PERMISSION_SCOPES.Master,
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-crown",
        eventKey: PATHS.MASTER_MANAGEMENT,
        items: [
          {
            title: "Cities",
            role: PERMISSION_SCOPES.Master,
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.CITIES}`,
            linkClassName: "text-black",
          },
          {
            title: "Zones",
            role: PERMISSION_SCOPES.Master,
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.ZONES}`,
            linkClassName: "text-black",
          },
          {
            title: "Club-Type",
            role: PERMISSION_SCOPES.Master,
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.CLUB_TYPE}`,
            linkClassName: "text-black",
          },
          {
            title: "Music-Type",
            role: PERMISSION_SCOPES.Master,
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.MUSIC_TYPE}`,
            linkClassName: "text-black",
          },
          {
            title: "OutFits",
            role: PERMISSION_SCOPES.Master,
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.OUTFITS}`,
            linkClassName: "text-black",
          },
          {
            title: "Drink Type",
            role: PERMISSION_SCOPES.Master,
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.DRINK_TYPE}`,
            linkClassName: "text-black",
          },
          {
            title: "Plans",
            role: PERMISSION_SCOPES.Master,
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.PLANS}`,
            linkClassName: "text-black",
          },
        ],
      },
      {
        title: "Category",
        role: PERMISSION_SCOPES.Category,
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-drag-indicator",
        eventKey: PATHS.CATEGORY,
        items: [
          {
            title: "Levels",
            role: PERMISSION_SCOPES.Category,
            type: MenuTypes.ITEM,
            href: `${PATHS.CATEGORY}/${PATHS.LEVELS}`,
            linkClassName: "text-black",
          },
          {
            title: "Super Levels",
            role: PERMISSION_SCOPES.Category,
            type: MenuTypes.ITEM,
            href: `${PATHS.CATEGORY}/${PATHS.SUPER_LEVELS}`,
            linkClassName: "text-black",
          },
          {
            title: "Benefits",
            role: PERMISSION_SCOPES.Category,
            type: MenuTypes.ITEM,
            href: `${PATHS.CATEGORY}/${PATHS.BENEFITS}`,
            linkClassName: "text-black",
          },
          {
            title: "Actions",
            role: PERMISSION_SCOPES.Category,
            type: MenuTypes.ITEM,
            href: `${PATHS.CATEGORY}/${PATHS.ACTIONS}`,
            linkClassName: "text-black",
          },
          {
            title: "Atmosphere Ranges",
            role: PERMISSION_SCOPES.Category,
            type: MenuTypes.ITEM,
            href: `${PATHS.CATEGORY}/${PATHS.ATMOSPHERE_RANGES}`,
            linkClassName: "text-black",
          },
          {
            title: "Queue Type",
            role: PERMISSION_SCOPES.Category,
            type: MenuTypes.ITEM,
            href: `${PATHS.CATEGORY}/${PATHS.QUE_TYPE}`,
            linkClassName: "text-black",
          },
          {
            title: "Gender Mix",
            role: PERMISSION_SCOPES.Category,
            type: MenuTypes.ITEM,
            href: `${PATHS.CATEGORY}/${PATHS.GENDER_MIX}`,
            linkClassName: "text-black",
          },
        ],
      },
      {
        title: "Reports",
        role: PERMISSION_SCOPES.Reports,
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-bar-chart",
        eventKey: PATHS.REPORTS,
        items: [
          {
            title: "Admin Monitoring",
            role: PERMISSION_SCOPES.Reports,
            type: MenuTypes.ITEM,
            href: `${PATHS.REPORTS}/${PATHS.ADMIN_MONITORING}`,
            linkClassName: "text-black",
          },
          {
            title: "User Reports",
            role: PERMISSION_SCOPES.Reports,
            type: MenuTypes.ITEM,
            href: `${PATHS.REPORTS}/${PATHS.SUPER_USER_REPORT}`,
            linkClassName: "text-black",
          },
          {
            title: "Club Reports",
            role: PERMISSION_SCOPES.Reports,
            type: MenuTypes.ITEM,
            href: `${PATHS.REPORTS}/${PATHS.SUPER_CLUB_REPORT}`,
            linkClassName: "text-black",
          },
          {
            title: "Brand Reports",
            role: PERMISSION_SCOPES.Reports,
            type: MenuTypes.ITEM,
            href: `${PATHS.REPORTS}/${PATHS.SUPER_BRAND_REPORT}`,
            linkClassName: "text-black",
          },
        ],
      },
      {
        title: "Manage Promotion",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.MangePromotions,
        href: PATHS.PROMOTION,
        icon: "inic inic-gift",
      },
      // {
      //   title: "Support",
      //   type: MenuTypes.ITEM,
      //   role: PERMISSION_SCOPES.Support,
      //   href: PATHS.SUPPORT,
      //   icon: "inic inic-support",
      // },
      {
        title: "Settings",
        type: MenuTypes.COLLAPSE,
        role: PERMISSION_SCOPES.Settings,
        icon: "inic inic-settings",
        eventKey: PATHS.SETTINGS,
        items: [
          {
            title: "General Settings",
            role: PERMISSION_SCOPES.Settings,
            type: MenuTypes.ITEM,
            href: `${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`,
            // linkClassName: "text-black",
          },
          // {
          //   title: "Social Media",
          //   role: PERMISSION_SCOPES.Settings,
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.SETTINGS}/${PATHS.SOCIAL_MEDIA}`,
          //   // linkClassName: "text-black",
          // },
          // {
          //   title: "Payment Gateway",
          //   role: PERMISSION_SCOPES.Settings,
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.SETTINGS}/${PATHS.PAYMENT_GATEWAY}`,
          //   // linkClassName: "text-black",
          // },
          {
            title: "SMTP Details",
            role: PERMISSION_SCOPES.Settings,
            type: MenuTypes.ITEM,
            href: `${PATHS.SETTINGS}/${PATHS.SMTP_SMS_DETAILS}`,
            // linkClassName: "text-black",
          },
          {
            title: "Email Notifications",
            role: PERMISSION_SCOPES.Settings,
            type: MenuTypes.ITEM,
            href: `${PATHS.SETTINGS}/${PATHS.EMAIL_NOTIFICATIONS}`,
            // linkClassName: "text-black",
          },
          {
            title: "Errors",
            role: PERMISSION_SCOPES.Settings,
            type: MenuTypes.COLLAPSE_LIST,
            eventKey: 0,
            items: [
              {
                title: "Error Messages",
                type: MenuTypes.ITEM,
                role: PERMISSION_SCOPES.Settings,
                href: `${PATHS.SETTINGS}/${PATHS.LANGUAGE_MESSAGES}`,
                // linkClassName: "text-black",
              },
              // {
              //   title: "Static Label",
              //   type: MenuTypes.ITEM,
              //   role: PERMISSION_SCOPES.Settings,
              //   href: `${PATHS.SETTINGS}/${PATHS.LANGAUGE_STATIC_LANG}`,
              //   // linkClassName: "text-black",
              // },
            ],
          },
        ],
      },
      // {
      //   title: "Common Pages",
      //   type: MenuTypes.COLLAPSE,
      //   role: "Common Pages",
      //   icon: "bx bxs-customize",
      //   eventKey: 5,
      //   items: [
      //     {
      //       title: "404",
      //       type: MenuTypes.ITEM,
      //       href: PATHS.FourZeroFour,
      //       linkClassName: "text-black",
      //     },
      //     {
      //       title: "Thank You",
      //       type: MenuTypes.ITEM,
      //       href: PATHS.THANKYOU,
      //       linkClassName: "text-black",
      //     },
      //     {
      //       title: "Coming Soon",
      //       type: MenuTypes.ITEM,
      //       href: PATHS.COMING_SOON,
      //       linkClassName: "text-black",
      //     },
      //   ],
      // },
    ],
  },
];

export const ClubAdminMenuList = [
  {
    title: "Main",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Dashboard",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Dashboard,
        badge: 4,
        badgeBg: "primary",
        badgeClassName: "badge-numeric",
        href: PATHS.DASHBOARD,
        icon: "inic inic-home",
      },
      {
        title: "Users",
        type: MenuTypes.COLLAPSE,
        role: PERMISSION_SCOPES.Users,
        icon: "inic inic-person",
        eventKey: PATHS.USER,
        items: [
          {
            title: "Worker List",
            role: PERMISSION_SCOPES.Workers,
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.WORKER_LIST}`,
            // linkClassName: "text-black",
          },
        ],
      },
      {
        title: "My Clubs",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Club,
        href: PATHS.CLUB,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-emoji-events",
      },
      {
        title: "Manage Points",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.ManagePoints,
        href: `${PATHS.MANAGE_POINTS}/${PATHS.ACTIONS}`,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-discount",
      },
      {
        title: "Manage Benefits",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.ManageBenefits,
        href: `${PATHS.MANAGE_BENEFITS}/${PATHS.BENEFITS}`,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-discount",
      },
    ],
  },
  {
    title: "General",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Manage Promotion",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.MangePromotions,
        href: PATHS.PROMOTION,
        icon: "inic inic-gift",
      },
      {
        title: "Reports",
        role: PERMISSION_SCOPES.Reports,
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-bar-chart",
        eventKey: PATHS.CLUB_ADMIN_REPORTS,
        items: [
          {
            title: "Club Monitoring",
            role: PERMISSION_SCOPES.Reports,
            type: MenuTypes.ITEM,
            href: `${PATHS.CLUB_ADMIN_REPORTS}${PATHS.CLUB_MONITOR_REPORTS}`,
            linkClassName: "text-black",
          },
          {
            title: "User Reports",
            role: PERMISSION_SCOPES.Reports,
            type: MenuTypes.ITEM,
            href: `${PATHS.CLUB_ADMIN_REPORTS}${PATHS.CLUB_USER_REPORTS}`,
            linkClassName: "text-black",
          },
        ],
      },
    ],
  },
];

export const BrandAdminMenuList = [
  {
    title: "Main",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Dashboard",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Dashboard,
        badge: 4,
        badgeBg: "primary",
        badgeClassName: "badge-numeric",
        href: PATHS.DASHBOARD,
        icon: "inic inic-home",
      },
      {
        title: "Users",
        type: MenuTypes.COLLAPSE,
        role: PERMISSION_SCOPES.Users,
        icon: "inic inic-person",
        eventKey: PATHS.USER,
        items: [
          {
            title: "Worker List",
            role: PERMISSION_SCOPES.Workers,
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.WORKER_LIST}`,
            // linkClassName: "text-black",
          },
        ],
      },
      {
        title: "Statistics",
        role: PERMISSION_SCOPES.Dashboard,
        type: MenuTypes.COLLAPSE,
        eventKey: PATHS.STATISTICS,
        icon: "inic inic-bar-chart",
        items: [
          {
            title: "Worker Statistics",
            role: PERMISSION_SCOPES.Dashboard,
            type: MenuTypes.ITEM,
            href: `${PATHS.STATISTICS}/${PATHS.WORKER_STATISTICS}`,
          },
          {
            title: "Worker Statistics Report",
            role: PERMISSION_SCOPES.Dashboard,
            type: MenuTypes.ITEM,
            href: `${PATHS.STATISTICS}/${PATHS.WORKER_STATISTICS_REPORT}`,
          },
        ],
      },
      {
        title: "Brand",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Brand,
        href: PATHS.BRAND,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-discount",
      },
      {
        title: "Manage Points",
        type: MenuTypes.ITEM,
        // role: PERMISSION_SCOPES.ManagePoints,
        href: PATHS.MANAGE_POINTS,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-discount",
      },
      {
        title: "Manage Benefits",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.ManageBenefits,
        href: `${PATHS.MANAGE_BENEFITS}/${PATHS.BENEFITS}`,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-discount",
      },
    ],
  },
  {
    title: "General",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Manage Promotion",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.MangePromotions,
        href: PATHS.PROMOTION,
        icon: "inic inic-gift",
      },
      {
        title: "Reports",
        role: PERMISSION_SCOPES.Reports,
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-bar-chart",
        eventKey: PATHS.BRAND_ADMIN_REPORTS,
        items: [
          {
            title: "Brand Monitoring",
            role: PERMISSION_SCOPES.Reports,
            type: MenuTypes.ITEM,
            href: `${PATHS.BRAND_ADMIN_REPORTS}${PATHS.BRAND_MONITOR_REPORTS}`,
            linkClassName: "text-black",
          },
          {
            title: "User Reports",
            role: PERMISSION_SCOPES.Reports,
            type: MenuTypes.ITEM,
            href: `${PATHS.BRAND_ADMIN_REPORTS}${PATHS.BRAND_USER_REPORTS}`,
            linkClassName: "text-black",
          },
        ],
      },
      {
        title: "Subscribers List",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.SubscribersList,
        href: PATHS.SUBSCRIBERS_LIST,
        icon: "inic inic-email",
      },
    ],
  },
];

export const MenuListCollapsed = [
  {
    title: "Dashboard",
    role: PERMISSION_SCOPES.Dashboard,
    icon: "inic inic-home",
    href: PATHS.DASHBOARD,
  },
  {
    title: "Users",
    role: PERMISSION_SCOPES.Users,
    icon: "inic inic-person",
    href: PATHS.USER,
  },
  {
    title: "Statistics",
    role: PERMISSION_SCOPES.Dashboard,
    icon: "inic inic-file",
    href: PATHS.STATISTICS,
  },
  {
    title: "Content",
    role: PERMISSION_SCOPES.Content,
    icon: "inic inic-file",
    href: PATHS.CONTENT,
  },
  {
    title: "Role",
    role: PERMISSION_SCOPES.Role,
    icon: "inic inic-circle-tick",
    href: PATHS.ROLE,
  },
  {
    title: "Email Templates",
    role: PERMISSION_SCOPES.Email_Template,
    icon: "inic inic-email",
    href: PATHS.EMAIL_TEMPLATES,
  },
  {
    title: "Master",
    role: PERMISSION_SCOPES.Master,
    icon: "inic inic-crown",
    href: PATHS.MASTER_MANAGEMENT,
  },
  {
    title: "Support",
    role: PERMISSION_SCOPES.Support,
    icon: "inic inic-support",
    href: PATHS.SUPPORT,
  },
  {
    title: "Settings",
    role: PERMISSION_SCOPES.Settings,
    icon: "inic inic-settings",
    href: PATHS.SETTINGS,
  },
];
